export const decodeBase64 = (base64)=>{

    // Decodificar la cadena base64 en un ArrayBuffer
    let bytes = new Uint8Array(atob(base64).split('').map(function (char) {
      return char.charCodeAt(0);
    }));
    
    // Crear un TextDecoder y decodificar los bytes en una cadena
    let decoder = new TextDecoder('utf-8');
    let decodedString = decoder.decode(bytes);
    
   return decodedString;
}